// PublicApp.js
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import { ConfigProvider } from 'antd/lib';
import es_ES from 'antd/es/locale/es_ES';
import { Provider } from 'react-redux';
import configureStore from '../store/configureStore';
import { createPublicClient } from './PublicApolloClient';
import AppPublic from './AppPublic';

// Redux store
const store = configureStore();
const client = createPublicClient();

const AppPublicContainer = () => {
  return (
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        <ConfigProvider locale={es_ES}>
          <Provider store={store}>
            <AppPublic />
          </Provider>
        </ConfigProvider>
      </ApolloHooksProvider>
    </ApolloProvider>
  );
};

export default AppPublicContainer;
